<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5QuxB7/tc-custom/9780369700780.jpg?1728259194113" alt="This image is the cover for the book Peril on the Mountain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peril on the Mountain
      </h1>
      <p class="bookDescription body article font2">
        <b>Love and danger in the Alaskan wilderness <br/><br/></b><b><i>Buried</i></b><br/><br/>After witnessing a murder, legal investigator Leah Marks flees to Alaska. But the killer has tracked her down and as he chases her into a snow-packed canyon, an avalanche buries them both. Saved by search-and-rescue specialist Cade Warren, Leah longs to tell him the truth. But how can she, without bringing even more danger into Cade’s life?<br/><br/><b><i>Untraceable</i></b><br/><br/>On a daring mission, search-and-rescue specialist Heidi Warren and her team step onto an icy Alaskan mountaintop…and right into a trap. A stranded gang of thieves holds them at gunpoint, forcing them to serve as guides along the treacherous path. Heidi needs someone to trust, but her rescue partner, Isaiah Callahan, is keeping secrets from her. Yet when a blizzard starts closing in, their options start running out…
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Goddard
      </h2>
      
      <p class="authorDescription body article">Elizabeth Goddard is the USA Today bestselling and award-winning author of more than fifty novels. Her books have sold over one million copies. She is a Carol Award winner and a Daphne du Maurier Award finalist. When she&#39;s not writing, she loves spending time with her family, traveling to find inspiration for her next book, and serving with her husband in ministry. For more information about her books, visit her website at www.ElizabethGoddard.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01469f04